import {Injectable} from '@angular/core';
import {NestApiProvider} from '../nest-api';
import {Observable} from 'rxjs';

@Injectable()
export class ComponentSettingApi {
  private readonly service: string = 'payroll';
  private readonly model: string = 'component-setting';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public getviewAddPayrollComponent(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getviewAddPayrollComponent';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public createcomponent(data): Observable<any> {
    const method: string = 'POST';
    const func: string = 'createcomponent';
    const params: any = data || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public updatecomponent(data): Observable<any> {
    const method: string = 'POST';
    const func: string = 'updatecomponent';
    const params: any = data || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/component-setting.api.ts